module.exports = __webpack_public_path__ + "img/nathan-pfp.2929a61b.png";